const STORAGE_PREFIX = 'entry-ecommerce:shop-session';
const TOKEN_QUERY_PARAM = 'returnTokenIfNoSession';

export function isIosSafariBrowser() {
  if (typeof navigator === 'undefined') return false;

  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const isTouchMac = platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const isIosDevice = /iPad|iPhone|iPod/.test(userAgent) || isTouchMac;
  const isSafari = /Safari/.test(userAgent) && !/(CriOS|FxiOS|EdgiOS|OPiOS|Chrome|Chromium)/.test(userAgent);

  return isIosDevice && isSafari;
}

export function isIframe() {
  if (typeof window === 'undefined') return false;

  try {
    return window.self !== window.top;
  } catch (error) {
    return true;
  }
}

export function getShopSessionToken() {
  if (!isIframe() || typeof window.sessionStorage === 'undefined') return null;

  try {
    return window.sessionStorage.getItem(STORAGE_PREFIX);
  } catch (error) {
    return null;
  }
}

export function setShopSessionToken(token) {
  if (!token) return;
  if (typeof window === 'undefined' || typeof window.sessionStorage === 'undefined') return;

  try {
    window.sessionStorage.setItem(STORAGE_PREFIX, token);
  } catch (error) {
    // Ignore storage failures and continue unauthenticated.
  }
}

export async function initShopSession(slug) {
  if (!slug) return null;
  if (!isIosSafariBrowser() || !isIframe()) return null;

  const existingToken = getShopSessionToken();
  if (existingToken) return existingToken;

  const baseUrl = `/api/v1/${encodeURIComponent(slug)}/session/check`;

  try {
    await fetch(baseUrl, {
      credentials: 'include',
      cache: 'no-store',
    });

    const response = await fetch(`${baseUrl}?${TOKEN_QUERY_PARAM}=true`, {
      credentials: 'include',
      cache: 'no-store',
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json().catch(() => ({}));
    if (data?.token) {
      setShopSessionToken(data.token);
      return data.token;
    }
  } catch (error) {
    return null;
  }

  return null;
}
